function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { Modal, Button, FormGroup, Label, P, Textarea, Input, reset, buttonReset, H, Tabs, theme } from '@raketa-cms/raketa-mir';
import Dropzone from 'react-dropzone';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var Img = function Img(_ref) {
  var src = _ref.src,
      variant = _ref.variant,
      className = _ref.className,
      onLoad = _ref.onLoad,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? null : _ref$alt,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "variant", "className", "onLoad", "alt", "title"]);

  if (!src) {
    console.warn("WARNING: Image with src null or undefined will not be rendered: " + variant + " " + (className || ''));
    return null;
  }

  var imgAlt = alt !== null ? alt : src.alt;
  var imgTitle = title !== null ? title : '';
  if (_typeof(src) === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant + " " + (className || ''));
  if (_typeof(src) === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return (
    /*#__PURE__*/
    React.createElement("img", _extends({
      src: src.urls.original,
      alt: imgAlt !== null ? imgAlt : src.name,
      className: className,
      onLoad: onLoad,
      title: imgTitle
    }, props))
  );
  if (_typeof(src) === 'object' && 'name' in src) return (
    /*#__PURE__*/
    React.createElement("img", _extends({
      src: src.urls[variant],
      alt: imgAlt !== null ? imgAlt : src.name,
      className: className,
      onLoad: onLoad,
      title: imgTitle
    }, props))
  );
  if (typeof src === 'string') return (
    /*#__PURE__*/
    React.createElement("img", _extends({
      src: src,
      alt: src,
      className: className,
      onLoad: onLoad,
      title: imgTitle
    }, props))
  );
  return null;
};

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  border-top: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 75vh;\n  overflow-y: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalContent = styled.div(_templateObject());
var ModalFooter = styled.div(_templateObject2(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.gray;
});

var Dialog = function Dialog(_ref) {
  var onClose = _ref.onClose,
      title = _ref.title,
      children = _ref.children,
      primaryLabel = _ref.primaryLabel,
      _ref$secondaryLabel = _ref.secondaryLabel,
      secondaryLabel = _ref$secondaryLabel === void 0 ? 'Cancel' : _ref$secondaryLabel,
      onPrimary = _ref.onPrimary;
  return (
    /*#__PURE__*/
    React.createElement(Modal, {
      title: title,
      onClose: onClose
    },
    /*#__PURE__*/
    React.createElement(ModalContent, null, children), (primaryLabel || secondaryLabel) &&
    /*#__PURE__*/
    React.createElement(ModalFooter, null, primaryLabel &&
    /*#__PURE__*/
    React.createElement(Button, {
      type: "button",
      variant: "primary",
      onClick: onPrimary
    }, primaryLabel), secondaryLabel &&
    /*#__PURE__*/
    React.createElement(Button, {
      type: "button",
      variant: "secondary",
      onClick: onClose
    }, secondaryLabel)))
  );
};

Dialog.defaultProps = {
  children: [],
  dialogSize: ''
};

var removeByIndex = function removeByIndex(items, idx) {
  return [].concat(items.slice(0, idx), items.slice(idx + 1));
};

var removeById = function removeById(items, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }

  return removeByIndex(items, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};

var randomString = function randomString(length) {
  return Math.random().toString(36).substring(length);
};

var TextField = function TextField(props) {
  var id = randomString();
  var label = props.label,
      hint = props.hint,
      multiline = props.multiline,
      _onChange = props.onChange;
  var inputProps = Object.assign({}, props);
  delete inputProps.label;
  delete inputProps.hint;
  delete inputProps.multiline;
  delete inputProps.onChange;
  var Component = multiline ? Textarea : Input;
  return (
    /*#__PURE__*/
    React.createElement(FormGroup, null, label ?
    /*#__PURE__*/
    React.createElement(Label, {
      htmlFor: id,
      error: props.error
    }, label) : '',
    /*#__PURE__*/
    React.createElement(Component, _extends({
      id: id,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }, inputProps)), hint ?
    /*#__PURE__*/
    React.createElement(P, null, hint) : '')
  );
};

var TextInput = function TextInput(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      placeholder = _ref.placeholder;
  return (
    /*#__PURE__*/
    React.createElement(TextField, {
      label: label,
      value: value,
      placeholder: placeholder,
      onChange: onChange
    })
  );
};

TextInput.defaultProps = {
  value: '',
  placeholder: ''
};

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  background-color: ", ";\n  font-size: 1em;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  line-height: 19px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: absolute;\n  bottom: 8px;\n  left: 12px;\n  background-color: ", ";\n  font-size: 0.85em;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  width: 100px;\n  height: 100px;\n  background-color: ", ";\n\n  & > img {\n    width: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  cursor: pointer;\n  width: 116px;\n  height: 116px;\n  border: 8px solid\n    ", ";\n\n  button {\n    display: none;\n  }\n\n  &:hover {\n    button {\n      display: inline-block;\n    }\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  margin-top: 1em;\n  min-height: 500px;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var IconEdit = function IconEdit() {
  return (
    /*#__PURE__*/
    React.createElement("img", {
      style: {
        width: '12px',
        margin: '0 auto'
      },
      src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5lZGl0LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iZWRpdC0yIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+ICAgICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxMyAwIDE4IDUgNSAxOCAwIDE4IDAgMTMiPjwvcG9seWdvbj4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg=="
    })
  );
};

var ImageList = styled.div(_templateObject$1(), reset);
var Thumb = styled.div(_templateObject2$1(), reset, function (props) {
  return props.selected ? props.theme.colors.success : 'transparent';
});
var ImageWrapper = styled.div(_templateObject3(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var EditButton = styled.button(_templateObject4(), reset, buttonReset, function (props) {
  return props.theme.colors.success;
});
var DeleteButton = styled.button(_templateObject5(), reset, buttonReset, function (props) {
  return props.theme.colors.danger;
});

var ImageItem = function ImageItem(_ref) {
  var image = _ref.image,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onFastSelect = _ref.onFastSelect,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit;
  return (
    /*#__PURE__*/
    React.createElement(Thumb, {
      selected: selected ? 'selected' : '',
      onClick: function onClick() {
        return onSelect(image);
      },
      onDoubleClick: function onDoubleClick() {
        return onFastSelect(image);
      }
    },
    /*#__PURE__*/
    React.createElement(ImageWrapper, {
      title: image.name
    },
    /*#__PURE__*/
    React.createElement(Img, {
      src: image,
      variant: "thumb"
    })),
    /*#__PURE__*/
    React.createElement(EditButton, {
      type: "button",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        onEdit(image);
      }
    },
    /*#__PURE__*/
    React.createElement(IconEdit, null)),
    /*#__PURE__*/
    React.createElement(DeleteButton, {
      type: "button",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        onDelete(image);
      }
    }, "\xD7"))
  );
};

var BrowseTab =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(BrowseTab, _React$Component);

  function BrowseTab(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedImage: _this.props.selectedImage || ''
    };
    return _this;
  }

  var _proto = BrowseTab.prototype;

  _proto.handleSelectImage = function handleSelectImage(selectedImage) {
    this.setState({
      selectedImage: selectedImage
    });
    this.props.onSelect(selectedImage);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        images = _this$props.images,
        q = _this$props.q,
        onFastSelect = _this$props.onFastSelect,
        onDelete = _this$props.onDelete,
        onSearch = _this$props.onSearch,
        onEdit = _this$props.onEdit;
    var selectedImage = this.state.selectedImage;
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(TextInput, {
        label: "Search images",
        value: q,
        onChange: function onChange(term) {
          return onSearch(term);
        }
      }),
      /*#__PURE__*/
      React.createElement(ImageList, null, images.map(function (image) {
        return (
          /*#__PURE__*/
          React.createElement(ImageItem, {
            key: image.id,
            image: image,
            selected: selectedImage.id === image.id,
            onSelect: function onSelect(onSelectedImage) {
              return _this2.handleSelectImage(onSelectedImage);
            },
            onFastSelect: onFastSelect,
            onDelete: onDelete,
            onEdit: onEdit
          })
        );
      })))
    );
  };

  return BrowseTab;
}(React.Component);

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 16px;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-bottom: 16px;\n  height: 350px;\n  color: #666;\n  background-color: #efefef;\n  border: 2px dashed #ddd;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledDropzone = styled.div(_templateObject$2());
var DropzoneLabel = styled.div(_templateObject2$2());

var Dropbox = function Dropbox(_ref) {
  var buttonLabel = _ref.buttonLabel,
      onDrop = _ref.onDrop;
  var dropzoneRef = React.createRef();

  var handleOpen = function handleOpen() {
    return dropzoneRef.current.open();
  };

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(StyledDropzone, null,
    /*#__PURE__*/
    React.createElement(Dropzone, {
      ref: dropzoneRef,
      onDrop: onDrop
    }, function (_ref2) {
      var getRootProps = _ref2.getRootProps,
          getInputProps = _ref2.getInputProps;
      return (
        /*#__PURE__*/
        React.createElement(DropzoneLabel, getRootProps(),
        /*#__PURE__*/
        React.createElement(H, {
          size: "large"
        }, "Select files from your computer"),
        /*#__PURE__*/
        React.createElement("small", null, "or drag and drop here"),
        /*#__PURE__*/
        React.createElement("input", getInputProps()))
      );
    })),
    /*#__PURE__*/
    React.createElement(Button, {
      type: "button",
      variant: "success",
      onClick: handleOpen,
      style: {
        marginBottom: '1em'
      }
    }, buttonLabel))
  );
};

Dropbox.defaultProps = {
  buttonLabel: 'Select files...'
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: 0.5em;\n  height: 2.4em;\n  font-size: 0.85em;\n  line-height: 2.4em;\n  color: #fff;\n  background-color: #4cae4c;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 2em;\n  background-color: #efefef;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var ProgressWrapper = styled.div(_templateObject$3());
var Progress = styled.div(_templateObject2$3());

var ProgressBar = function ProgressBar(_ref) {
  var total = _ref.total,
      done = _ref.done;
  var progress = 100 / total * done;
  return (
    /*#__PURE__*/
    React.createElement(ProgressWrapper, null,
    /*#__PURE__*/
    React.createElement(Progress, {
      style: {
        width: progress + "%"
      }
    }, done, "/", total))
  );
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  min-height: 400px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var FileItem = function FileItem(_ref) {
  var file = _ref.file;
  return (
    /*#__PURE__*/
    React.createElement("div", null,
    /*#__PURE__*/
    React.createElement("strong", null, file.name),
    /*#__PURE__*/
    React.createElement("span", null, "Completed"))
  );
};

var FileList = function FileList(_ref2) {
  var files = _ref2.files;
  return (
    /*#__PURE__*/
    React.createElement("div", null, files.map(function (file) {
      return (
        /*#__PURE__*/
        React.createElement(FileItem, {
          key: file.id,
          file: file
        })
      );
    }))
  );
};

var ImageUploader = styled.div(_templateObject$4());

var UploadTab =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(UploadTab, _React$Component);

  function UploadTab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UploadTab.prototype;

  _proto.isUploading = function isUploading() {
    return this.props.filesToUpload !== this.props.filesUploaded;
  };

  _proto.renderProgress = function renderProgress() {
    var _this$props = this.props,
        filesToUpload = _this$props.filesToUpload,
        filesUploaded = _this$props.filesUploaded,
        files = _this$props.files;
    return (
      /*#__PURE__*/
      React.createElement("div", null,
      /*#__PURE__*/
      React.createElement(ProgressBar, {
        total: filesToUpload,
        done: filesUploaded
      }),
      /*#__PURE__*/
      React.createElement(FileList, {
        files: files
      }))
    );
  };

  _proto.render = function render() {
    var _this = this;

    return (
      /*#__PURE__*/
      React.createElement(ImageUploader, null, !this.isUploading() ?
      /*#__PURE__*/
      React.createElement(Dropbox, {
        onDrop: function onDrop(files) {
          return _this.props.onUpload(files);
        },
        buttonLabel: "Select files"
      }) : null, this.isUploading() ? this.renderProgress() : null)
    );
  };

  return UploadTab;
}(React.Component);

var MediaManagerContext = React.createContext({});

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-bottom: 16px;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 16px;\n\n  & > img {\n    object-fit: contain;\n    width: 100px;\n    height: 100px;\n    background-color: #ddd;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var ImageWrapper$1 = styled.div(_templateObject$5());
var ImageControl = styled.div(_templateObject2$4());

var withMediaManager = function withMediaManager(Component) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(MediaManagerContext.Consumer, null, function (mediaManager) {
        return (
          /*#__PURE__*/
          React.createElement(Component, _extends({
            mediaManager: mediaManager
          }, props))
        );
      })
    );
  };
};

var ImagePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ImagePicker, _React$Component);

  function ImagePicker(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.state = {
      pickerOpen: false,
      selectedImage: props.value || false,
      filesToUpload: 0,
      filesUploaded: 0,
      images: [],
      files: [],
      q: ''
    };
    _this.mediaManager = props.mediaManager || context.mediaManager;
    return _this;
  }

  var _proto = ImagePicker.prototype;

  _proto.fetchData = function fetchData(q, callback) {
    var _this2 = this;

    var params = q !== '' && q.length > 2 ? {
      q: q
    } : {};
    this.mediaManager.findAll(function (images) {
      _this2.setState({
        images: images
      }, function () {
        return callback();
      });
    }, params);
  };

  _proto.handleUpload = function handleUpload(files) {
    var _this3 = this;

    this.setState({
      filesToUpload: files.length,
      filesUploaded: 0,
      files: []
    }, function () {
      files.forEach(function (file) {
        _this3.mediaManager.uploadFile(file, function (response) {
          var _this3$state = _this3.state,
              files = _this3$state.files,
              q = _this3$state.q;

          _this3.setState({
            filesUploaded: _this3.state.filesUploaded + 1,
            files: [].concat(files, [response])
          }, function () {
            if (_this3.state.filesToUpload === _this3.state.filesUploaded) {
              _this3.fetchData(q, function () {});
            }
          });
        });
      });
    });
  };

  _proto.handleOpenPicker = function handleOpenPicker() {
    var _this4 = this;

    var q = this.state.q;
    this.fetchData(q, function () {
      _this4.setState({
        pickerOpen: true
      });
    });
  };

  _proto.handleSelectImage = function handleSelectImage() {
    var _this5 = this;

    this.setState({
      pickerOpen: false
    }, function () {
      if (_this5.props.onChange) _this5.props.onChange(_this5.state.selectedImage);
    });
  };

  _proto.handleClearImage = function handleClearImage() {
    var _this6 = this;

    this.setState({
      selectedImage: false
    }, function () {
      if (_this6.props.onChange) _this6.props.onChange(_this6.state.selectedImage);
    });
  };

  _proto.handleFastSelect = function handleFastSelect(image) {
    var _this7 = this;

    this.setState({
      selectedImage: image,
      pickerOpen: false
    }, function () {
      if (_this7.props.onChange) _this7.props.onChange(_this7.state.selectedImage);
    });
  };

  _proto.handleDeleteImage = function handleDeleteImage(image) {
    var _this8 = this;

    if (!confirm('Are you sure? ')) return;
    var images = this.state.images;
    this.mediaManager.destroy(image, function (deletedImage) {
      _this8.setState({
        images: removeById(images, deletedImage.id)
      });
    });
  };

  _proto.handleSearch = function handleSearch(q) {
    var _this9 = this;

    this.setState({
      q: q
    }, function () {
      return _this9.fetchData(q, function () {});
    });
  };

  _proto.handleEditImage = function handleEditImage(image) {
    this.setState({
      imageDialogOpen: true,
      editImage: image,
      alt: image.alt || ''
    });
  };

  _proto.handleUpdateImage = function handleUpdateImage(editImage) {
    var _this10 = this;

    var _this$state = this.state,
        alt = _this$state.alt,
        images = _this$state.images,
        selectedImage = _this$state.selectedImage;

    if (images.length > 0) {
      var imageIdx = images.findIndex(function (currentImage) {
        return currentImage.id === editImage.id;
      });
      var newImages = [].concat(images.slice(0, imageIdx), [Object.assign({}, images[imageIdx], {
        alt: alt
      })], images.slice(imageIdx + 1));
      this.setState({
        images: newImages
      });
    }

    if (parseInt(selectedImage.id, 10) === parseInt(editImage.id, 10)) {
      this.setState({
        selectedImage: Object.assign({}, selectedImage, {
          alt: alt
        })
      }, function () {
        if (_this10.props.onChange) _this10.props.onChange(_this10.state.selectedImage);
      });
    }

    var self = this;
    this.mediaManager.update(editImage, {
      alt: alt
    }, function () {
      self.setState({
        imageDialogOpen: false
      });
    });
  };

  _proto.render = function render() {
    var _this11 = this;

    var _this$props$label = this.props.label,
        label = _this$props$label === void 0 ? 'Image' : _this$props$label;
    var _this$state2 = this.state,
        pickerOpen = _this$state2.pickerOpen,
        filesToUpload = _this$state2.filesToUpload,
        filesUploaded = _this$state2.filesUploaded,
        images = _this$state2.images,
        selectedImage = _this$state2.selectedImage,
        files = _this$state2.files,
        q = _this$state2.q;
    return (
      /*#__PURE__*/
      React.createElement("div", null,
      /*#__PURE__*/
      React.createElement(ImageControl, null, selectedImage &&
      /*#__PURE__*/
      React.createElement(ImageWrapper$1, null,
      /*#__PURE__*/
      React.createElement(Img, {
        src: selectedImage,
        variant: "thumb",
        title: selectedImage.name
      })),
      /*#__PURE__*/
      React.createElement(FormGroup, null,
      /*#__PURE__*/
      React.createElement(Label, null, label + " " + (selectedImage.alt ? "(" + selectedImage.alt + ")" : '')),
      /*#__PURE__*/
      React.createElement(Button, {
        type: "button",
        variant: "secondary",
        onClick: function onClick() {
          return _this11.handleOpenPicker();
        }
      }, "Browse..."),
      /*#__PURE__*/
      React.createElement(Button, {
        type: "button",
        variant: "secondary",
        onClick: function onClick() {
          return _this11.handleClearImage();
        }
      }, "Clear"))), pickerOpen &&
      /*#__PURE__*/
      React.createElement(Dialog, {
        open: pickerOpen,
        onClose: function onClose() {
          return _this11.setState({
            pickerOpen: false
          });
        },
        title: "Image Browser",
        primaryLabel: "Select",
        onPrimary: function onPrimary() {
          return _this11.handleSelectImage();
        }
      },
      /*#__PURE__*/
      React.createElement(Tabs, null,
      /*#__PURE__*/
      React.createElement("div", {
        title: "Browse"
      },
      /*#__PURE__*/
      React.createElement(BrowseTab, {
        images: images,
        selectedImage: selectedImage,
        q: q,
        onSearch: function onSearch(q) {
          return _this11.handleSearch(q);
        },
        onSelect: function onSelect(image) {
          return _this11.setState({
            selectedImage: image
          });
        },
        onFastSelect: function onFastSelect(image) {
          return _this11.handleFastSelect(image);
        },
        onDelete: function onDelete(image) {
          return _this11.handleDeleteImage(image);
        },
        onEdit: function onEdit(image) {
          return _this11.handleEditImage(image);
        }
      })),
      /*#__PURE__*/
      React.createElement("div", {
        title: "Upload"
      },
      /*#__PURE__*/
      React.createElement(UploadTab, {
        filesToUpload: filesToUpload,
        filesUploaded: filesUploaded,
        files: files,
        onUpload: function onUpload(filesOnUpload) {
          return _this11.handleUpload(filesOnUpload);
        }
      })))))
    );
  };

  return ImagePicker;
}(React.Component);

ImagePicker.contextTypes = {
  host: PropTypes.string,
  mediaManager: PropTypes.object
};
var ImagePicker$1 = withMediaManager(ImagePicker);

var ImageInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ImageInput, _React$Component);

  function ImageInput(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedImage: props.image || false
    };
    return _this;
  }

  var _proto = ImageInput.prototype;

  _proto.handleChange = function handleChange(selectedImage) {
    var _this2 = this;

    this.setState({
      selectedImage: selectedImage
    }, function () {
      if (_this2.props.onChange) _this2.props.onChange(selectedImage);
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        name = _this$props.name,
        mediaManager = _this$props.mediaManager;
    var selectedImage = this.state.selectedImage;
    return (
      /*#__PURE__*/
      React.createElement(ThemeProvider, {
        theme: theme
      },
      /*#__PURE__*/
      React.createElement("div", null,
      /*#__PURE__*/
      React.createElement(ImagePicker$1, {
        mediaManager: mediaManager,
        value: selectedImage,
        onChange: function onChange(selectedImage) {
          return _this3.handleChange(selectedImage);
        }
      }),
      /*#__PURE__*/
      React.createElement("input", {
        type: "hidden",
        name: name,
        value: selectedImage ? selectedImage.id : ''
      })))
    );
  };

  return ImageInput;
}(React.Component);

var imgageSrc = function imgageSrc(src, variant) {
  if (_typeof(src) === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant);
  if (_typeof(src) === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return src.urls.original;
  if (_typeof(src) === 'object' && 'name' in src) return src.urls[variant];
  if (typeof src === 'string') return src;
  return null;
};

var imgPlaceholder = function imgPlaceholder(size) {
  return "https://placehold.it/" + size;
};

var serialize = function serialize(params) {
  return Object.keys(params).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
};

var get = function get(url, params, opts) {
  if (params === void 0) {
    params = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  return fetch(url + "?" + serialize(params), opts);
};

var patch = function patch(url, params, opts) {
  if (params === void 0) {
    params = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  return fetch(url, Object.assign({
    method: 'PATCH',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};

var post = function post(url, params, opts) {
  if (params === void 0) {
    params = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  return fetch(url, Object.assign({
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};

var del = function del(url, params, opts) {
  if (params === void 0) {
    params = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  return fetch(url, Object.assign({
    method: 'DELETE',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};

var MediaManager =
/*#__PURE__*/
function () {
  function MediaManager(baseUrl) {
    this.baseUrl = baseUrl;
  }

  var _proto = MediaManager.prototype;

  _proto.findAll = function findAll(callback, params) {
    if (params === void 0) {
      params = {};
    }

    get(this.baseUrl + "images", params).then(function (r) {
      return r.json();
    }).then(function (images) {
      return callback(images);
    });
  };

  _proto.uploadFile = function uploadFile(file, callback) {
    var body = new FormData();
    body.append('image[asset]', file);
    post(this.baseUrl + "images", {}, {
      body: body
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };

  _proto.update = function update(image, params, callback) {
    patch(this.baseUrl + "images/" + image.id, {
      image: params
    }, {
      headers: {
        'content-type': 'application/json'
      }
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };

  _proto.destroy = function destroy(image, callback) {
    del(this.baseUrl + "images/" + image.id, {}, {
      headers: {
        'content-type': 'application/json'
      }
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };

  return MediaManager;
}();

export { ImageInput, ImagePicker$1 as ImagePicker, Img, MediaManager, MediaManagerContext, imgPlaceholder as imagePlaceholder, imgageSrc as imageSrc };